import Hero from './hero'
import Studios from './studios'
import StudioPerformance from './studio-performance'
import QuoteTitle from './quote-title'
import Commission from './commission'
import Freedom from './freedom'
import Promotion from './promotion'
import Feedback from './feedback'

export default function JoinUs({ initData }) {
  const t = useI18n()

  return (
    <div>
      <Hero />
      <div className='px-8'>
        <QuoteTitle>{ t('page:joinUs.quote.title1') }</QuoteTitle>
        <Commission newCustomerCount={ initData.studioPerformance.newCustomerCount } avgRevenue={ initData.studioPerformance.avgRevenue }/>
        <div className='mt-14'>
          <Freedom/>
        </div>
        <QuoteTitle>{ t('page:joinUs.quote.title2') }</QuoteTitle>
        <Promotion avgTeamPayout={ initData.studioPerformance.avgTeamPayout }/>
        <div className='mt-14'>
          <StudioPerformance performance={ initData.studioPerformance }/>
        </div>
        <div className='-translate-y-10 md:translate-y-0'>
          <Feedback/>
        </div>
        <Studios studios={ initData.studios }/>
      </div>
    </div>
  )
}
